const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-joblog/shared/lib/stage-overview-header-dropdown-registry");